/**
 * Ошибки биллинга приходят как {"detail": {"code": "...", "message": "..."}}.
 * Ошибки валидации FastAPI — {"detail": [{"loc": [...], "msg": "..."}]}.
 */
export class BillingError extends Error {
    constructor(code, message, status = 0, fields = []) {
        super(message)
        this.code = code
        this.status = status
        // Имена полей запроса с ошибкой валидации (например, documents_email)
        this.fields = fields
    }
}

const DEFAULT_MESSAGES = {
    403: 'Управлять оплатой может только владелец компании',
    404: 'Не найдено',
}

export function toBillingError(error) {
    if (error instanceof BillingError) {
        return error
    }
    const response = error && error.response
    if (!response) {
        return new BillingError('network_error', 'Сервис оплаты недоступен. Проверьте подключение и попробуйте ещё раз')
    }
    const status = response.status
    const detail = response.data && response.data.detail
    if (detail && typeof detail === 'object' && !Array.isArray(detail) && detail.code) {
        return new BillingError(detail.code, detail.message || DEFAULT_MESSAGES[status] || 'Ошибка', status)
    }
    if (Array.isArray(detail)) {
        const fields = detail.map((item) => (item.loc || [])[item.loc.length - 1]).filter(Boolean)
        const message = detail.map((item) => item.msg).filter(Boolean).join('; ') || 'Проверьте введённые данные'
        return new BillingError('validation_error', message, status, fields)
    }
    if (typeof detail === 'string') {
        return new BillingError(`http_${status}`, detail, status)
    }
    return new BillingError(`http_${status}`, DEFAULT_MESSAGES[status] || 'Не удалось выполнить запрос, попробуйте позже', status)
}

export function isPromoError(error) {
    return !!(error && error.code && error.code.startsWith('promo_'))
}

// Ошибки DaData по ИНН: показываем у поля ИНН
export const INN_FIELD_ERRORS = ['inn_not_found', 'company_liquidated']

export const CARD_NOT_CONFIGURED = 'card_payments_not_configured'
